{
  "general": {
    "yes": "Yes",
    "no": "No"
  },
  "navigation": {
    "next": "Next",
    "ok": "OK"
  },
  "frontpage": {
    "description": "Consent to case processing",
    "p1": "A case has been created at SOS International. In order to process the case, we need your consent",
    "readmoreHeader": "Read more",
    "readmoreText": "Read what you consent to here",
    "yourCase": "Your case information",
    "case": "See case number and other information about the case",
    "consent": "I consent to SOS International processing my personal data",
    "ok": "Yes, I agree"
  },
  "status": {
    "description": "Status of consent",
    "p1": "Your consent is received",
    "p1Text1": "Thank you for your consent",
    "p1Text2": "Consent is received - we can now process the case",
    "date": "Date of your consent",
    "readmoreText": "Read what you consent to here"
  },
  "consent": {
    "description": "Consent",
    "back": "< Back"
  },
  "case": {
    "description": "Case information",
    "info": "Your case information",
    "number": "Case number",
    "date": "Date of case creation",
    "insurance": "Insurance company"
  },
  "doctor": {
    "description": "Doctor overview",
    "number": "Case number",
    "date_created": "Date of case creation",
    "date_accpted": "Date of consent",
    "consent_given": "Consent given",
    "consent_not_given": "Consent NOT given"
  },
  "patient": {
    "description": "Your consent",
    "consent": "Consent to case processing",
    "attorney": "Power of attorney",
    "recourse": "Regres consent",
    "caseinfo": "My information"
  },
  "ac": {
    "description": "Travelcare Alarm Centre overview",
    "consent_header": "Case processing consent",
    "consent": "See Consent",
    "attorney_header": "Consent to power of attorney",
    "attorney": "See Power of Attorney",
    "recourse_header": "Regress given",
    "recourse": "See Regress"
  },
  "user": {
    "description": "My consents ",
    "consent": "Consent processing",
    "yourCase": "Your case information"
  },
  "error": {
    "description": "An error has occurred",
    "consent_404": "The entered ID does not exist in our system - please contact SOS International. We are sorry",
    "doctor_404": "The entered ID does not exist in our system - please contact SOS International. We are sorry",
    "ac_404": "The entered ID does not exist in our system - please contact SOS International. We are sorry",
    "approve": "It was not possible to give your consent due to a technical error - please contact SOS International. We are sorry",
    "default": "Something went wrong. Please try again later",
    "technical": "Something went wrong. Please try again later"
  }
}
